/*
 * BusinessUp — Sepet satır birleştirme düzeltmesi
 *
 * Neden var:
 * `cart-line-items.liquid` aynı variant'a ait birden fazla satırı (ör. Monk
 * hediye satırı + normal satır) tek bir görsel satırda birleştiriyor. Temanın
 * kendi "Kaldır" mantığı tek bir satır anahtarı bildiği için birleşik satırı
 * tam kaldıramıyor. Bu dosya tıklamaları yakalayıp satırın TÜM anahtarlarını
 * tek `cart/update.js` çağrısında sıfırlar.
 *
 * ÖNEMLİ: Bu kod daha önce `cart-line-items.liquid` içinde satır içi <script>
 * olarak duruyordu. Sepet çekmecesi içeriği `innerHTML` ile yazıldığı için o
 * script ASLA çalışmıyordu; çekmecede "Kaldır" tamamen bozuktu. Bu yüzden
 * gerçek bir asset dosyasına taşındı ve theme.liquid'den yükleniyor.
 */
(function () {
  if (window.customCartSplitFix) return;
  window.customCartSplitFix = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // `.cart-message` hem ücretsiz kargo çubuğunu hem de `.cart-message--custom`
  // promosyon şeridini yakalıyordu; yanlış elemana yazınca sayfada birbiriyle
  // çelişen iki kargo mesajı birden görünüyordu.
  var SYNC = [
    '#cartItemsHolder',
    '[data-cart-price-holder]',
    '[data-cart-items-qty]',
    // Ödeme butonundaki tutar (`.cart__total__money`) `[data-cart-price-holder]`
    // içinde DEĞİL, `[data-cart-checkout-button]` içinde duruyor. Listede
    // olmadığı için sepet değişince güncellenmiyor ve buton eski tutarda
    // donuyordu (ör. ürün silindikten sonra 2.278 TL yazmaya devam etmesi).
    '[data-cart-total-price]',
    '[data-cart-total]',
    '.cart-message:not(.cart-message--custom)',
    '.cart__empty',
    '.cart__aside',
    '[data-items-wrapper]'
  ];

  function keysFrom(el) {
    var raw = el.getAttribute('data-all-keys') || el.getAttribute('data-variant-keys') || '';
    var keys = raw.split(',').map(function (k) { return k.trim(); }).filter(Boolean);
    if (keys.length) return keys;
    // Yedek: birleştirme yoksa satırın kendi anahtarı yeter. Eskiden burada
    // sessizce return ediliyordu ve tıklama yutulduğu için hiçbir şey olmuyordu.
    var single = (el.getAttribute('data-id') || '').trim();
    return single ? [single] : [];
  }

  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-item-remove]');
    if (!removeBtn) return;

    var keys = keysFrom(removeBtn);
    if (!keys.length) return; // anahtar yoksa temanın kendi mantığına bırak

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });
    sendBatchCartUpdate(updates);
  }, true);

  document.addEventListener('click', function (e) {
    var minusBtn = e.target.closest('[data-quantity-minus]');
    var plusBtn = e.target.closest('[data-quantity-plus]');
    if (!minusBtn && !plusBtn) return;

    var counter = e.target.closest('quantity-counter') || e.target.closest('[data-quantity-holder]');
    if (!counter) return;
    var input = counter.querySelector('input[data-quantity-field]');
    if (!input) return;

    var keys = keysFrom(input);
    if (!keys.length) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var qty = parseInt(input.value, 10) || 0;
    var max = parseInt(input.getAttribute('data-quantity-max'), 10) || 99;
    var min = parseInt(input.getAttribute('data-quantity-min'), 10) || 0;
    qty = minusBtn ? Math.max(min, qty - 1) : Math.min(max, qty + 1);
    input.value = qty;

    applyQuantity(keys, qty);
  }, true);

  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('input[data-quantity-field]')) return;
    var keys = keysFrom(e.target);
    if (!keys.length) return;

    e.stopPropagation();
    e.stopImmediatePropagation();
    applyQuantity(keys, parseInt(e.target.value, 10) || 0);
  }, true);

  function applyQuantity(keys, qty) {
    var updates = {};
    // Birleşik satırda adet ilk anahtarda toplanır, kalan bölünmüş satırlar sıfırlanır.
    keys.forEach(function (k, i) { updates[k] = i === 0 ? qty : 0; });
    sendBatchCartUpdate(updates);
  }

  /*
   * Sepet dışı sayfalarda tema, çekmecenin TAMAMINI bir <template> içinde
   * render edip çalışma anında sayfaya klonluyor. <template> içeriği ana DOM
   * ağacında olmadığı için düz `doc.querySelector` bu elemanları bulamıyor;
   * eskiden senkron sessizce atlanıyor ve ürün silinse bile çekmece
   * güncellenmiyordu. Bu yüzden template içlerine de bakıyoruz.
   */
  function pick(doc, selector) {
    var hit = doc.querySelector(selector);
    if (hit) return hit;
    var templates = doc.querySelectorAll('template');
    for (var i = 0; i < templates.length; i++) {
      var inner = templates[i].content && templates[i].content.querySelector(selector);
      if (inner) return inner;
    }
    return null;
  }

  function setBusy(on) {
    var drawer = document.querySelector('.cart-drawer');
    if (drawer) drawer.classList.toggle('is-loading', on);
  }

  function showError(message) {
    var holder = document.querySelector('[data-cart-errors]');
    if (!holder) return;
    var msg = holder.querySelector('[data-error-message]');
    if (msg) msg.textContent = message;
    holder.classList.add('is-expanded');
  }

  async function sendBatchCartUpdate(updates) {
    setBusy(true);
    var cartUpdated = false;

    try {
      var res = await fetch(ROOT + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ updates: updates })
      });

      var data = await res.json();
      if (!res.ok || data.errors) {
        throw new Error(data.description || data.message || 'Sepet güncellenemedi.');
      }
      cartUpdated = true;

      // Sunucudan taze işaretlemeyi al: hangi satırların göründüğü, boş sepet
      // mesajı ve kargo çubuğu tek doğruluk kaynağı olarak buradan gelir.
      var bust = new URL(window.location.href);
      bust.searchParams.set('_cache', Date.now());
      var pageRes = await fetch(bust.toString(), { cache: 'no-store', credentials: 'same-origin' });
      if (!pageRes.ok) throw new Error('Sepet görünümü yenilenemedi.');

      var doc = new DOMParser().parseFromString(await pageRes.text(), 'text/html');

      SYNC.forEach(function (selector) {
        var next = pick(doc, selector);
        var current = document.querySelector(selector);
        if (!next || !current) return;
        current.innerHTML = next.innerHTML;
        // Sepet boşalınca `hidden` sınıfları da değişiyor; sadece innerHTML
        // kopyalamak boş sepet mesajını gizli, ödeme kutusunu açık bırakıyordu.
        current.className = next.className;
      });

      // Temanın quantity-counter bileşenleri yeniden bağlanıp tek anahtarlı
      // çakışan istek göndermesin diye etkisizleştiriliyor.
      document.querySelectorAll('quantity-counter').forEach(function (qc) {
        var div = document.createElement('div');
        Array.from(qc.attributes).forEach(function (a) { div.setAttribute(a.name, a.value); });
        div.innerHTML = qc.innerHTML;
        qc.replaceWith(div);
      });

      setBusy(false);
      // Monk hediye widget'ı ve custom.js bu olayları dinliyor.
      document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: data } }));
      document.dispatchEvent(new CustomEvent('theme:cart:reload'));
    } catch (err) {
      console.error('Cart update error:', err);
      if (cartUpdated) {
        window.location.reload();
        return;
      }
      setBusy(false);
      showError(err.message);
    }
  }
})();
